import { render } from "./LokasiView.vue?vue&type=template&id=f4150010&scoped=true"
import script from "./LokasiView.vue?vue&type=script&lang=js"
export * from "./LokasiView.vue?vue&type=script&lang=js"

import "./LokasiView.vue?vue&type=style&index=0&id=f4150010&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4150010"]])

export default __exports__